// START AUTHENTIC JS
const section = document.querySelector(".authentic-swiper-section");
if (section) {
  const container = section.querySelector(".mySwiper-authenic");
  const swiper = new Swiper(container, {
    slidesPerView: 2,
    slidesPerGroup: 1,
    spaceBetween: 10,
    watchOverflow: true, // Swiper locks when not enough slides
    navigation: {
      nextEl: container.querySelector(".swiper-button-next"),
      prevEl: container.querySelector(".swiper-button-prev"),
    },
    pagination: {
      el: container.querySelector(".swiper-pagination"),
      clickable: true,
    },
    breakpoints: {
      640:  { slidesPerView: 2, spaceBetween: 20 },
      768:  { slidesPerView: 2, spaceBetween: 40 },
      1024: { slidesPerView: 3, spaceBetween: 30 },
      1350: { slidesPerView: 4, spaceBetween: 20 },
    },
    on: {
      // works across versions
      init(sw) { togglePagination(sw); },
      afterInit(sw) { togglePagination(sw); },   // some versions fire this
      resize(sw) { togglePagination(sw); },
      breakpoint(sw) { togglePagination(sw); },
      slidesLengthChange(sw) { togglePagination(sw); },
    }
  });
  function togglePagination(sw) {
    const pagEl = sw.pagination?.el || sw.el.querySelector(".swiper-pagination");
    if (!pagEl) return;
    // effective slidesPerView at this width
    const perView = sw.params.slidesPerView === 'auto'
      ? sw.slidesPerViewDynamic()
      : sw.params.slidesPerView;
    const shouldShow = sw.slides.length > perView && !sw.isLocked; // isLocked when watchOverflow
    pagEl.style.display = shouldShow ? "block" : "none";
  }
}
// END AUTHENTIC JS


// START Read More / Read Less JS
document.addEventListener('DOMContentLoaded', function(){
  document.querySelectorAll('.rm-toggle').forEach(function(btn){
    const panel = document.getElementById(btn.getAttribute('aria-controls'));
    if (!panel) return;
    // start collapsed
    btn.setAttribute('aria-expanded', 'false');
    panel.style.maxHeight = '0px';
    const setOpen = (open) => {
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      btn.textContent = open ? 'Read Less' : 'Read More…';
      panel.style.maxHeight = open ? panel.scrollHeight + 'px' : '0px';
    };
    btn.addEventListener('click', () => {
      const open = btn.getAttribute('aria-expanded') === 'true';
      setOpen(!open);
    });
    // keep height correct if content wraps differently on resize
    window.addEventListener('resize', () => {
      if (btn.getAttribute('aria-expanded') === 'true') {
        panel.style.maxHeight = panel.scrollHeight + 'px';
      }
    });
  });
});
// END Read More / Read Less JS